import { render, staticRenderFns } from "./TabProfile.vue?vue&type=template&id=1df2dfe5&"
import script from "./TabProfile.vue?vue&type=script&lang=js&"
export * from "./TabProfile.vue?vue&type=script&lang=js&"
import style0 from "./TabProfile.vue?vue&type=style&index=0&id=1df2dfe5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports